export const trackPendoEvent = (
  name: string,
  properties: Record<string, string | number | boolean>
) => {
  window.pendo?.track?.(name, properties);
};
